import React, { useState, useEffect } from "react";
import LoadingSpinner from "./LoadingSpinner";
import {  FiDownload } from "react-icons/fi";
import { HiOutlinePhotograph } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { HiOutlineTrash } from "react-icons/hi2";
import {truncateFileName ,FormattedFileSize } from "../Functions/TextTransform";
import { useTranslation } from "react-i18next";

const UploadedFileItem = ({ file, onDelete, formatFileSize , pageLanguage }) => {

  const isImage = file.type?.startsWith("image/");
  const isPdf = file.type === "application/pdf";
  const isError = file.status === "error" || !!file.errorMessage;
  const errorType = file.errorType;
  const [pdfLoading, setPdfLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false); 
  const [imageIconLoading, setImageIconLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (isPdf) {
      const timer = setTimeout(() => setPdfLoading(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isPdf]);

  useEffect(() => {
    if (isImage && file.url) {
      const timer = setTimeout(() => setImageIconLoading(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isImage, file.url]);



  const handleDeleteClick = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      await onDelete(file.id);
    } catch (err) {
      console.error("Delete failed in component", err);
      setIsDeleting(false); 
    }
  };

  const isReady = !isError && (file.status === "success" || (file.url && !file.errorMessage));
  const isIconLoaded = (isImage && !imageIconLoading) || (isPdf && !pdfLoading);
  const showDeleteIcon = isReady && isIconLoaded && !isDeleting;
  const isUploading = file.status === "pending" || file.status === "uploading";
  const colorIcon = isError ? "error-colorIcon" : "";

  let previewContent;
  const showLoadingText = isUploading || isDeleting;

  if (isUploading) {
    previewContent = (
      <div className="image-loading-wrapper">
        <LoadingSpinner />
      </div>
    );
  } else if (isError && (errorType === "size" || errorType === "format")) {
    previewContent = <div className="stepRequired" style={{width:"1.5rem" , height:"1.5rem"}} />;
  }else if (isDeleting) {
    previewContent =  <div className="image-loading-wrapper">
    <LoadingSpinner />
  </div>;
  } else if (isImage && file.url) {
    previewContent = (
      <>
        {imageIconLoading && (
          <div className="image-loading-wrapper">
            <LoadingSpinner  />
          </div>
        )}
        <div style={{ display: imageIconLoading ? 'none' : 'block' }}>
          <HiOutlinePhotograph size={24}  />
        </div>
      </>
    );
  } else if (isPdf) {
    previewContent = (
      <>
        {pdfLoading && (
          <div className="image-loading-wrapper">
            <LoadingSpinner  />
          </div>
        )}
        <div style={{ display: pdfLoading ? 'none' : 'block' }}>
          <IoDocumentTextOutline size={24}  className={`${colorIcon}`}  />
        </div>
      </>
    );
  } else {
    previewContent = <FiDownload size={24} />;
  }

  const borderClass = isError ? "error-borderUploadFileNew" : "";
  const fileSize = file.uploadedSize || file.size;
  const fileSizeInBytes = fileSize; 
  const formattedSize = formatFileSize(fileSizeInBytes); // "150.67 KB"
  const isSuccess = !isError && (file.status === "success" || (file.url && !file.errorMessage));

  return (
    <div className={`upload-file-itemUploadFileNew ${borderClass}`}>
      <div  className={`file-previewUploadFileNew 2`}>{previewContent}</div>
      <div  className={`file-infoUploadFileNew ${
          pageLanguage === "fa" ? "file-previewUploadFileNew-fa" : "file-previewUploadFileNew-en"
        }`}>
        <div className={`${isError ? "file-nameUploadFileNew-error" :"file-nameUploadFileNew"}`}>
        {truncateFileName(file.name, 17)}
        </div>
        {showLoadingText && (
          <div className="loadingSpan">
             {t("Loading...")}
          </div>
        )}
        {isError && file.errorMessage && (
          <div className="file-statusUploadFileNew error-statusUploadFileNew">{file.errorMessage}</div>
        )}
        {isSuccess && fileSize && !showLoadingText && (
          <div className="file-statusUploadFileNew success-statusUploadFileNew">
           <IoIosCheckmarkCircle size={24}  className="success-icon"/>
           {t("UploadSuccessful")}   {pageLanguage === "en" 
      ? formattedSize 
      : <FormattedFileSize sizeString={formattedSize} />
    }
          </div>
        )}
      </div>
      <button
  className={
    showDeleteIcon 
      ? "btn-remove-img" 
      : isError 
        ? "btn-close4" 
        : "btn-close btn-close2"
  }
  onClick={handleDeleteClick}
  disabled={isDeleting}
>
  {isUploading ? (
    "" 
  ) : showDeleteIcon ? (
    <HiOutlineTrash className="btn-remove-show" />
  ) : isError ? (
    <HiOutlineTrash className="btn-remove-error" />
  ) : (
    <span></span>
  )}
</button>
    </div>
  );
};

export default UploadedFileItem;